var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActiveSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.48999C20.7 7.48999 24.51 11.3 24.51 16C24.51 20.7 20.7 24.51 16 24.51",
    fill: "#F36F4B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.51 15.5H16V16.5H24.51V15.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 12.66H16V13.66H23.75V12.66Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.09 9.83002H16V10.83H22.09V9.83002Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 18.34H16V19.34H23.75V18.34Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.09 21.17H16V22.17H22.09V21.17Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.01 25.02C11.04 25.02 7 20.98 7 16.01C7 11.04 11.04 7 16.01 7V8C11.59 8 8 11.59 8 16.01C8 20.43 11.59 24.02 16.01 24.02V25.02Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4412 10.3051L25.5219 11.5149L25.9048 12.4387L28.824 11.2289L28.4412 10.3051Z",
    fill: "#CCCCCC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09833 19.5623L3.17908 20.7721L3.56192 21.6959L6.48117 20.4861L6.09833 19.5623Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9087 19.5564L25.5261 20.4803L28.4455 21.6895L28.8282 20.7657L25.9087 19.5564Z",
    fill: "#CCCCCC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5545 10.3022L3.17181 11.2261L6.09127 12.4354L6.47396 11.5115L3.5545 10.3022Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2305 3.1823L10.3065 3.56482L11.5153 6.48449L12.4392 6.10197L11.2305 3.1823Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4918 25.5111L19.5678 25.8936L20.7766 28.8133L21.7005 28.4308L20.4918 25.5111Z",
    fill: "#CCCCCC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7731 3.17984L19.5633 6.09909L20.4871 6.48194L21.6969 3.56269L20.7731 3.17984Z",
    fill: "#CCCCCC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5159 25.5271L10.3062 28.4464L11.23 28.8292L12.4398 25.9099L11.5159 25.5271Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.01H15.5V6.98999H16C20.97 6.98999 25.01 11.03 25.01 16C25.01 20.97 20.97 25.01 16 25.01ZM16.5 8.00999V24C20.68 23.74 24.01 20.26 24.01 16.01C24.01 11.76 20.69 8.27999 16.5 8.01999V8.00999Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSun);
export default __webpack_public_path__ + "static/media/ActiveSun.abfae0d89d5aad5884c19986472d4da1.svg";
export { ForwardRef as ReactComponent };